import { DownloadLink } from 'components/DownloadLink'
import { EntityList, EntityListProps } from 'components/EntityList'
import { Participant, ProvingDocument } from 'model'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type DocumentListProps = EntityListProps<
  ProvingDocument & { particiant?: Participant }
>

export const DocumentList: React.FunctionComponent<DocumentListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const replacedString = (stringToReplace: any) => {
    stringToReplace = stringToReplace.replace(/%20/g, ' ')
    stringToReplace = stringToReplace.replace(/o%CC%88/g, 'ö')
    stringToReplace = stringToReplace.replace(/O%CC%88/g, 'Ö')
    stringToReplace = stringToReplace.replace(/u%CC%88/g, 'ü')
    stringToReplace = stringToReplace.replace(/U%CC%88/g, 'Ü')
    stringToReplace = stringToReplace.replace(/a%CC%88/g, 'ä')
    stringToReplace = stringToReplace.replace(/A%CC%88/g, 'Ä')
    stringToReplace = stringToReplace.replace(/%C3%9F/g, 'ß')
    stringToReplace = stringToReplace.replace(/%2C/g, ',')
    return stringToReplace
  }
  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={[
        fieldColumn('file', {
          ungroupable: true,
          fieldName: 'name',
          onRender: (item: any) => {
            return (
              <DownloadLink uri={item.uri}>
                {replacedString(item.name)}
              </DownloadLink>
            )
          },
        }),
        fieldColumn('type'),
        fieldColumn('participant', {
          fieldName: 'participant',
          onRender: (item: any) => {
            return (
              <span>
                {item.participant && item.participant.person
                  ? item.participant.person.name
                  : ''}
              </span>
            )
          },
          ungroupable: true,
          getGroupValue: (item) =>
            item.participant && item.participant.person
              ? item.participant.person.name
              : '',
        }),
      ]}
      {...props}
    />
  )
}
